module.exports = __webpack_public_path__ + "static/img/ent-detail-75.128f707.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-75.jpg
// module id = C0OB
// module chunks = 52